/**
 * 依頼返却金融機関名取得API
 * レスポンス - レスポンス業務エリア
 */

export interface Sgkd042aResponseDto {
  /** 依頼返却金融機関名 */
  reqretFinancialinstitutionname?: string;
}
